export const Language = {
  en: {
    title_text: "Welcome to your",
    title_text_2: "Digital Instructions on Occupational Safety",
    privacy_agree_text: "I have read and agree to the",
    privacy_agree_link: "Privacy Notice & Terms of Use",
    privacy_agree_text_2: "",
    next_button_statement:
      'To continue, please activate the checkbox "I have read the Privacy Notice & Terms of Use ...".',
    imprint_button: "Imprint",
    language_text: "Language",
    button_next: "Next step",
    welcome_message: "Welcome to the TenneT Training Portal for our projects!",
    select_training_message: "Here you can select relevant training sessions.",
    button_continue: "Continue",
    select_structure_type: "Please select the type of structure",
    module_selection: "Module selection",
    mandatory_modules: "Mandatory modules",
    optional_modules: "Optional modules",
    select_modules_message:
      "Please select the training modules you wish to complete. Please note that mandatory training sessions are required. You can arrange the training sessions in any order you prefer. The training sessions will be displayed in the order you set here.",
    button_next_2: "Next",
  },
  de: {
    title_text: "Willkommen zu Ihrer",
    title_text_2: "Digitalen Einweisung Arbeitssicherheit",
    privacy_agree_text: "Ich habe die",
    privacy_agree_link: "Datenschutzhinweise",
    privacy_agree_text_2: "gelesen und bin damit einverstanden.",
    next_button_statement:
      'Bitte klicken Sie zum Fortfahren auf das Kontrollkästchen neben der Erklärung "Ich habe die Datenschutzhinweise & Nutzungsbedingungen gelesen ...".',
    imprint_button: "Impressum",
    language_text: "Sprache",
    button_next: "Zum nächsten Schritt",
    welcome_message: "Willkommen auf dem TenneT-Schulungsportal für unsere Projekte!",
    select_training_message: "Hier können Sie das für Sie relevante Projekt auswählen",
    button_continue: "Weiter",
    select_structure_type: "Bitte wählen Sie die Art des Bauwerks aus",
    module_selection: "Modulwahl",
    mandatory_modules: "Pflichtmodule",
    optional_modules: "Optionale Module",
    select_modules_message:
      "Bitte wählen Sie die Schulungsmodule aus, die Sie absolvieren möchten. Bitte beachten Sie, dass die Pflichtschulungen obligatorisch sind. Sie können die Reihenfolge der Schulungen gerne nach Ihren Wünschen anpassen. Die Schulungen werden in der Reihenfolge angezeigt, die Sie hier festlegen.",
    button_next_2: "Weiter",
  },
  du: {
    title_text: "Selecteer taal",
    subtitle_text: "Selecteer de gevraagde taal",
    language_text: "Taal",
    privacy_agree_text:
      'Ik heb de <a href="./privacyStatement"> privacyverklaring en gebruiksvoorwaarden </a> gelezen en ik ga akkoord',
    next_button_statement:
      'Klik op het selectievakje naast de stelling "Ik heb uw privacyverklaring gelezen" om verder te gaan.',
    imprint_button: "Afdruk",
    button_next: "Volgende stap",
    welcome_message: "Welkom op het TenneT-trainingsportaal voor onze projecten!",
    select_training_message: "Hier kunt u relevante trainingen selecteren.",
    button_continue: "Doorgaan",
    select_structure_type: "Selecteer het type constructie",
    module_selection: "Modulekeuze",
    mandatory_modules: "Verplichte modules",
    optional_modules: "Optionele modules",
    select_modules_message:
      "Selecteer de trainingsmodules die u wilt volgen. Houd er rekening mee dat verplichte trainingen verplicht zijn. U kunt de volgorde van de trainingen naar wens aanpassen. De trainingen worden weergegeven in de volgorde die u hier instelt.",
    button_next_2: "Volgende",
  },
  fr: {
    title_text: "Sélectionnez la langue",
    subtitle_text: "Veuillez sélectionner la langue souhaitée",
    language_text: "La langue",
    privacy_agree_text:
      "J'ai lu <a href='./privacyStatement'>la déclaration de confidentialité et les conditions d'utilisation</a> et je les accepte",
    next_button_statement:
      "Veuillez cliquer sur la case à cocher à côté de la déclaration J'ai lu votre déclaration de confidentialité pour continuer.",
    imprint_button: "Mentions légales",
    button_next: "Étape suivante",
    welcome_message: "Bienvenue sur le portail de formation TenneT pour nos projets!",
    select_training_message: "Ici, vous pouvez sélectionner les formations pertinentes.",
    button_continue: "Continuer",
    select_structure_type: "Veuillez sélectionner le type de structure",
    module_selection: "Sélection de module",
    mandatory_modules: "Modules obligatoires",
    optional_modules: "Modules optionnels",
    select_modules_message:
      "Veuillez sélectionner les modules de formation que vous souhaitez suivre. Notez que les formations obligatoires sont requises. Vous pouvez organiser les formations dans l'ordre que vous préférez. Elles seront affichées dans l'ordre que vous avez défini ici.",
    button_next_2: "Suivant",
  },
  es: {
    title_text: "Seleccione el idioma",
    subtitle_text: "Por favor seleccione el idioma solicitado",
    language_text: "Idioma",
    privacy_agree_text:
      "<a href='./privacyStatement'>He leído la declaración de privacidad y los términos de uso y estoy de acuerdo</a>",
    next_button_statement:
      "Por favor haga clic en la casilla de verificación junto a la declaración He leído su declaración de privacidad para proceder.",
    imprint_button: "Imprimir",
    button_next: "Siguiente paso",
    welcome_message: "¡Bienvenido al portal de capacitación de TenneT para nuestros proyectos!",
    select_training_message: "Aquí puede seleccionar las capacitaciones relevantes.",
    button_continue: "Continuar",
    select_structure_type: "Por favor seleccione el tipo de estructura",
    module_selection: "Selección de módulos",
    mandatory_modules: "Módulos obligatorios",
    optional_modules: "Módulos opcionales",
    select_modules_message:
      "Seleccione los módulos de capacitación que desea completar. Tenga en cuenta que las capacitaciones obligatorias son necesarias. Puede organizar las sesiones de capacitación en el orden que prefiera. Se mostrarán en el orden que establezca aquí.",
    button_next_2: "Siguiente",
  },
  it: {
    title_text: "Selezionare la lingua",
    subtitle_text: "Si prega di selezionare la lingua richiesta",
    language_text: "Lingua",
    privacy_agree_text:
      "<a href='./privacyStatement'>Ho letto l'informativa sulla privacy e le condizioni d'uso e accetto</a>",
    next_button_statement:
      "Per favore cliccate sulla casella di controllo accanto alla dichiarazione Ho letto la vostra dichiarazione sulla privacy per procedere",
    imprint_button: "Impronta",
    button_next: "Passo successivo",
    welcome_message: "Benvenuti nel portale di formazione TenneT per i nostri progetti!",
    select_training_message: "Qui puoi selezionare le formazioni rilevanti.",
    button_continue: "Continua",
    select_structure_type: "Si prega di selezionare il tipo di struttura",
    module_selection: "Selezione dei moduli",
    mandatory_modules: "Moduli obbligatori",
    optional_modules: "Moduli opzionali",
    select_modules_message:
      "Seleziona i moduli di formazione che desideri completare. Si prega di notare che le formazioni obbligatorie sono obbligatorie. Puoi organizzare le sessioni di formazione nell'ordine che preferisci. Verranno visualizzate nell'ordine che imposti qui.",
    button_next_2: "Avanti",
  },
  pt: {
    title_text: "Seleccionar Língua",
    subtitle_text: "Por favor seleccione a língua solicitada",
    language_text: "Língua",
    privacy_agree_text:
      "<a href='./privacyStatement'>Li a declaração de privacidade e os termos de utilização e concordo</a>",
    next_button_statement:
      "Por favor clique na caixa de verificação ao lado da declaração que li para prosseguir.",
    imprint_button: "Imprimir",
    button_next: "Próximo passo",
    welcome_message: "Bem-vindo ao portal de treinamento TenneT para nossos projetos!",
    select_training_message: "Aqui você pode selecionar treinamentos relevantes.",
    button_continue: "Continuar",
    select_structure_type: "Por favor, selecione o tipo de estrutura",
    module_selection: "Seleção de módulo",
    mandatory_modules: "Módulos obrigatórios",
    optional_modules: "Módulos opcionais",
    select_modules_message:
      "Selecione os módulos de treinamento que deseja concluir. Observe que os treinamentos obrigatórios são necessários. Você pode organizar as sessões de treinamento na ordem que preferir. Eles serão exibidos na ordem que você definir aqui.",
    button_next_2: "Próximo",
  },
  po: {
    title_text: "Wybierz język",
    subtitle_text: "Proszę wybrać żądany język",
    language_text: "Język",
    privacy_agree_text:
      "<a href='./privacyStatement'>Przeczytałem oświadczenie o ochronie prywatności i warunki użytkowania i zgadzam się z nimi</a>",
    next_button_statement:
      "Proszę kliknąć na pole wyboru obok oświadczenia które przeczytałem w oświadczeniu o ochronie prywatności aby kontynuować",
    imprint_button: "Odcisk",
    button_next: "Następny krok",
    welcome_message: "Witamy na portalu szkoleniowym TenneT dla naszych projektów!",
    select_training_message: "Tutaj możesz wybrać odpowiednie szkolenia.",
    button_continue: "Kontyntynuj",
    select_structure_type: "Proszę wybrać typ struktury",
    module_selection: "Wybór modułów",
    mandatory_modules: "Moduły obowiązkowe",
    optional_modules: "Moduły opcjonalne",
    select_modules_message:
      "Proszę wybrać moduły szkoleniowe, które chcesz ukończyć. Pamiętaj, że szkolenia obowiązkowe są wymagane. Możesz ustawić kolejność modułów według uznania. Szkolenia zostaną wyświetlone w kolejności ustawionej tutaj.",
    button_next_2: "Dalej",
  },

  ru: {
    title_text: "Добро пожаловать в ваш",
    title_text_2: "Цифровой инструктаж по охране труда",
    privacy_agree_text: "Я прочитал(а) и согласен(на) с",
    privacy_agree_link: "Уведомлением о конфиденциальности и условиями использования",
    privacy_agree_text_2: "",
    next_button_statement:
      'Чтобы продолжить, пожалуйста, отметьте флажок "Я прочитал Уведомление о конфиденциальности и условия использования ...".',
    imprint_button: "Импрессум",
    language_text: "Язык",
    button_next: "Следующий шаг",
    welcome_message: "Добро пожаловать на портал обучения TenneT для наших проектов!",
    select_training_message: "Здесь вы можете выбрать соответствующие курсы обучения.",
    button_continue: "Продолжить",
    select_structure_type: "Пожалуйста, выберите тип конструкции",
    module_selection: "Выбор модуля",
    mandatory_modules: "Обязательные модули",
    optional_modules: "Необязательные модули",
    select_modules_message:
      "Пожалуйста, выберите модули обучения, которые вы хотите пройти. Обратите внимание, что обязательные курсы обучения являются обязательными. Вы можете настроить порядок проведения обучения в соответствии с вашими предпочтениями. Они будут отображаться в порядке, установленном вами здесь.",
    button_next_2: "Далее",
  },

  tr: {
    title_text: "Hoş geldiniz",
    title_text_2: "İş Güvenliği Dijital Talimatlarına",
    privacy_agree_text: "Okudum ve kabul ediyorum",
    privacy_agree_link: "Gizlilik Bildirimi ve Kullanım Şartlarını",
    privacy_agree_text_2: "",
    next_button_statement:
      'Devam etmek için lütfen "Gizlilik Bildirimini ve Kullanım Şartlarını okudum ..." ifadesinin yanındaki kutucuğu işaretleyin.',
    imprint_button: "Künye",
    language_text: "Dil",
    button_next: "Sonraki adım",
    welcome_message: "Projelerimiz için TenneT Eğitim Portalına Hoş Geldiniz!",
    select_training_message: "Burada ilgili eğitim oturumlarını seçebilirsiniz.",
    button_continue: "Devam et",
    select_structure_type: "Lütfen yapı türünü seçin",
    module_selection: "Modül seçimi",
    mandatory_modules: "Zorunlu modüller",
    optional_modules: "Opsiyonel modüller",
    select_modules_message:
      "Tamamlamak istediğiniz eğitim modüllerini seçiniz. Zorunlu eğitimlerin gerekli olduğunu unutmayın. Eğitim oturumlarını istediğiniz sıraya göre düzenleyebilirsiniz. Burada ayarladığınız sıraya göre gösterilecektir.",
    button_next_2: "İleri",
  },

  el: {
    title_text: "Καλώς ήρθατε στο",
    title_text_2: "Ψηφιακό Οδηγό Ασφάλειας στην Εργασία",
    privacy_agree_text: "Έχω διαβάσει και συμφωνώ με",
    privacy_agree_link: "την Ειδοποίηση Απορρήτου και τους Όρους Χρήσης",
    privacy_agree_text_2: "",
    next_button_statement:
      'Για να συνεχίσετε, ενεργοποιήστε το πλαίσιο ελέγχου "Έχω διαβάσει την Ειδοποίηση Απορρήτου και τους Όρους Χρήσης ..."',
    imprint_button: "Αποτύπωμα",
    language_text: "Γλώσσα",
    button_next: "Επόμενο βήμα",
    welcome_message: "Καλώς ήρθατε στην εκπαιδευτική πύλη της TenneT για τα έργα μας!",
    select_training_message: "Εδώ μπορείτε να επιλέξετε σχετικές εκπαιδευτικές συνεδρίες.",
    button_continue: "Συνέχεια",
    select_structure_type: "Παρακαλώ επιλέξτε τον τύπο κατασκευής",
    module_selection: "Επιλογή μονάδας",
    mandatory_modules: "Υποχρεωτικές μονάδες",
    optional_modules: "Προαιρετικές μονάδες",
    select_modules_message:
      "Επιλέξτε τις εκπαιδευτικές μονάδες που θέλετε να ολοκληρώσετε. Σημειώστε ότι οι υποχρεωτικές εκπαιδεύσεις είναι υποχρεωτικές. Μπορείτε να οργανώσετε τις συνεδρίες με οποιαδήποτε σειρά προτιμάτε. Οι συνεδρίες θα εμφανιστούν με τη σειρά που ορίσατε εδώ.",
    button_next_2: "Επόμενο",
  },

  bg: {
    title_text: "Добре дошли във вашето",
    title_text_2: "Дигитално ръководство за безопасност при работа",
    privacy_agree_text: "Прочетох и съм съгласен с",
    privacy_agree_link: "Известието за поверителност и Условията за ползване",
    privacy_agree_text_2: "",
    next_button_statement:
      'За да продължите, моля, активирайте квадратчето "Прочетох Известието за поверителност и Условията за ползване ..."',
    imprint_button: "Импресия",
    language_text: "Език",
    button_next: "Следваща стъпка",
    welcome_message: "Добре дошли в обучителния портал на TenneT за нашите проекти!",
    select_training_message: "Тук можете да изберете съответните обучения.",
    button_continue: "Продължи",
    select_structure_type: "Моля, изберете типа на конструкцията",
    module_selection: "Избор на модул",
    mandatory_modules: "Задължителни модули",
    optional_modules: "Незадължителни модули",
    select_modules_message:
      "Моля, изберете обучителните модули, които искате да преминете. Моля, имайте предвид, че задължителните обучения са необходими. Можете да организирате учебните сесии в реда, който предпочитате. Ще се покажат в реда, който зададете тук.",
    button_next_2: "Напред",
  },

  ro: {
    title_text: "Bine ați venit la",
    title_text_2: "Instrucțiunile digitale pentru siguranța muncii",
    privacy_agree_text: "Am citit și sunt de acord cu",
    privacy_agree_link: "Notificarea de confidențialitate și Termenii de utilizare",
    privacy_agree_text_2: "",
    next_button_statement:
      'Pentru a continua, vă rugăm să bifați caseta "Am citit Notificarea de confidențialitate și Termenii de utilizare ...".',
    imprint_button: "Amprentă",
    language_text: "Limbă",
    button_next: "Pasul următor",
    welcome_message: "Bine ați venit pe portalul de instruire TenneT pentru proiectele noastre!",
    select_training_message: "Aici puteți selecta sesiuni de instruire relevante.",
    button_continue: "Continuare",
    select_structure_type: "Vă rugăm să selectați tipul de structură",
    module_selection: "Selectarea modului",
    mandatory_modules: "Module obligatorii",
    optional_modules: "Module opționale",
    select_modules_message:
      "Vă rugăm să selectați modulele de instruire pe care doriți să le finalizați. Rețineți că sesiunile obligatorii sunt necesare. Puteți organiza sesiunile în orice ordine preferați. Acestea vor fi afișate în ordinea stabilită aici.",
    button_next_2: "Următorul",
  },

  cs: {
    title_text: "Vítejte v",
    title_text_2: "Digitálním návodu pro bezpečnost práce",
    privacy_agree_text: "Přečetl(a) jsem a souhlasím s",
    privacy_agree_link: "Prohlášením o ochraně osobních údajů a Podmínkami použití",
    privacy_agree_text_2: "",
    next_button_statement:
      'Pro pokračování prosím aktivujte zaškrtávací políčko "Přečetl(a) jsem Prohlášení o ochraně osobních údajů a Podmínky použití ...".',
    imprint_button: "Tisk",
    language_text: "Jazyk",
    button_next: "Další krok",
    welcome_message: "Vítejte na vzdělávacím portálu TenneT pro naše projekty!",
    select_training_message: "Zde si můžete vybrat relevantní školení.",
    button_continue: "Pokračovat",
    select_structure_type: "Prosím, vyberte typ konstrukce",
    module_selection: "Výběr modulů",
    mandatory_modules: "Povinné moduly",
    optional_modules: "Volitelné moduly",
    select_modules_message:
      "Vyberte si školící moduly, které chcete dokončit. Pamatujte, že povinné školení je vyžadováno. Můžete uspořádat školení v libovolném pořadí podle vlastních preferencí. Školení se zobrazí v pořadí, které zde nastavíte.",
    button_next_2: "Další",
  },

  sh: {
    title_text: "Dobrodošli u vaš",
    title_text_2: "Digitalni uputstva za sigurnost na radu",
    privacy_agree_text: "Pročitao/la sam i slažem se sa",
    privacy_agree_link: "Obaveštenjem o privatnosti i Uslovima korišćenja",
    privacy_agree_text_2: "",
    next_button_statement:
      'Da biste nastavili, molimo označite polje "Pročitao/la sam Obaveštenje o privatnosti i Uslove korišćenja ...".',
    imprint_button: "Impresum",
    language_text: "Jezik",
    button_next: "Sledeći korak",
    welcome_message: "Dobrodošli na portal za obuku TenneT za naše projekte!",
    select_training_message: "Ovde možete odabrati relevantne trening sesije.",
    button_continue: "Nastavite",
    select_structure_type: "Molimo odaberite tip strukture",
    module_selection: "Izbor modula",
    mandatory_modules: "Obavezni moduli",
    optional_modules: "Opcioni moduli",
    select_modules_message:
      "Molimo odaberite module za obuku koje želite završiti. Imajte na umu da su obavezni treninzi neophodni. Možete organizovati sesije u bilo kojem redosledu koji vam odgovara. Prikazaće se redosled koji postavite ovde.",
    button_next_2: "Dalje",
  },

  hu: {
    title_text: "Üdvözöljük a",
    title_text_2: "Digitális munkavédelmi útmutatójában",
    privacy_agree_text: "Elolvastam és elfogadom a",
    privacy_agree_link: "Adatvédelmi nyilatkozatot és Felhasználási feltételeket",
    privacy_agree_text_2: "",
    next_button_statement:
      'A folytatáshoz kérjük, aktiválja a jelölőnégyzetet "Elolvastam az Adatvédelmi nyilatkozatot és a Felhasználási feltételeket ...".',
    imprint_button: "Lenyomat",
    language_text: "Nyelv",
    button_next: "Következő lépés",
    welcome_message: "Üdvözöljük a TenneT képzési portálján projektjeinkhez!",
    select_training_message: "Itt kiválaszthatja a releváns képzési modulokat.",
    button_continue: "Folytatás",
    select_structure_type: "Kérjük, válassza ki a szerkezet típusát",
    module_selection: "Modul kiválasztása",
    mandatory_modules: "Kötelező modulok",
    optional_modules: "Opcionális modulok",
    select_modules_message:
      "Kérjük, válassza ki a befejezni kívánt képzési modulokat. Felhívjuk figyelmét, hogy a kötelező képzések szükségesek. A képzési modulokat tetszőleges sorrendben szervezheti. Az itt megadott sorrendben jelennek meg.",
    button_next_2: "Tovább",
  },
};
